<template>
  <v-container class="pa-0" fluid grid-list-md>
    <v-layout row wrap>
      <v-flex sm4>
        <v-text-field
          label="Name"
          v-model="u.name"
          @input="$v.u.name.$touch()"
          @blur="$v.u.name.$touch()"
          :error-messages="nameErrors"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm4>
        <v-text-field
          label="Username"
          v-model="u.username"
          @input="$v.u.username.$touch()"
          @blur="$v.u.username.$touch()"
          :error-messages="usernameErrors"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm4>
        <v-text-field
          label="Password"
          type="password"
          v-model="u.password"
          @input="touchPassword"
          @blur="touchPassword"
          :error-messages="passwordErrors"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm4>
        <v-text-field
          label="Email"
          v-model="u.email"
          @input="$v.u.email.$touch()"
          @blur="$v.u.email.$touch()"
          :error-messages="emailErrors"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm4>
        <v-text-field
          label="Telephone"
          v-model="u.telephone"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm4>
        <departments-list
          v-model="u.department"
          :outlined="outlinedInputs"
        ></departments-list>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm4>
        <v-select
          :items="userTypes.edges"
          v-model="u.typeId"
          label="User type"
          item-text="node.name"
          item-value="node.id"
          :error-messages="userTypeErrors"
          :outlined="outlinedInputs"
        ></v-select>
      </v-flex>
      <v-flex sm4>
        <v-checkbox
          @change="onChangeData(u)"
          v-model="sendItineraryNotification"
          label="Send Itinerary Email Notification"
          primary
          hide-details
        ></v-checkbox>
      </v-flex>
      <v-flex sm4>
        <v-checkbox
          @change="onChangeData(u)"
          v-model="u.isActive"
          label="Active"
          primary
          hide-details
        ></v-checkbox>
      </v-flex>
      <v-flex sm4>
        <v-checkbox
          @change="onChangeData(u)"
          v-model="u.notInUse"
          label="Not in Use"
          primary
          hide-details
        ></v-checkbox>
      </v-flex>
    </v-layout>
    <div v-if="debug">{{ u.id }}</div>
  </v-container>
</template>

<script>
import DepartmentsList from "../../../gt/shared/DepartmentListSelect";
import BrandListSelect from "../../shared/BrandListSelect";
import DestinationListSelect from "../../shared/DestinationListSelect";
import { USER_TYPES_QUERY } from "../../../../constants/graphql";
import { email, required } from "vuelidate/lib/validators";

export default {
  name: "UserEditorDetails",

  components: {
    DepartmentsList,
    DestinationListSelect,
    BrandListSelect,
  },

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    userEditorDialog: {
      type: Boolean,
      default: false,
    },
    touchDetails: {
      type: Boolean,
      default: false,
    },
    usernameTakenError: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      debug: false,
      userTypes: {},
      u: { ...this.user },

      showValidation: true,
      usernameErrorsArray: [],
      sendItineraryNotification: this.user.config
        ? this.user.config.sendItineraryNotification
        : false,
    };
  },

  methods: {
    onDepartmentSelect(payload) {
      this.u.department = payload.name;
      this.onChangeData(this.u);
    },
    onChangeData(data) {
      let isValid = !this.$v.$invalid;
      const user = {
        ...data,
        config: {
          sendItineraryNotification: this.sendItineraryNotification,
        },
      };
      this.$emit("onChange", { ...user }, isValid);
    },
    touchPassword() {
      if (this.user.id == null) {
        this.$v.u.password.$touch();
      }
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.u.name.$dirty) {
        return errors;
      }
      if (!this.$v.u.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
    usernameErrors() {
      let errors = [];
      if (!this.$v.u.username.$dirty && this.usernameTakenError == false) {
        return errors;
      }
      if (!this.$v.u.username.required) {
        errors.push("Username is required.");
      }
      if (this.usernameTakenError) {
        errors.push("Please select different username");
      }
      return errors;
    },
    passwordErrors() {
      let errors = [];
      if (this.user.id != null || !this.$v.u.password.$dirty) {
        return errors;
      }
      if (!this.$v.u.password.required) {
        errors.push("Password is required.");
      }
      return errors;
    },
    emailErrors() {
      let errors = [];
      if (!this.$v.u.email.$dirty) {
        return errors;
      }
      if (!this.$v.u.email.email) {
        errors.push("Input must be an email.");
      }
      if (!this.$v.u.email.required) {
        errors.push("Email is required.");
      }
      return errors;
    },
    userTypeErrors() {
      let errors = [];
      if (!this.$v.u.typeId.$dirty) {
        return errors;
      }
      if (!this.$v.u.typeId.required) {
        errors.push("User type is required.");
      }
      return errors;
    },
  },

  watch: {
    user(data) {
      this.u = { ...data };
      this.sendItineraryNotification = data.config
        ? data.config.sendItineraryNotification
        : false;
    },

    u: {
      handler(data) {
        this.onChangeData(data);
      },

      deep: true,
    },

    userEditorDialog(value) {
      if (value) {
        this.$v.$reset();
      } else {
        this.sendItineraryNotification = false;
      }
    },

    touchDetails(value) {
      if (value) {
        this.$v.$touch();
        this.$emit("onTouchDetails");
      }
    },
  },

  apollo: {
    userTypes: {
      query: USER_TYPES_QUERY,
      fetchPolicy: "network-only",

      result({ data, loader, networkStatus }) {},
    },
  },

  validations() {
    if (this.user.id == null) {
      return {
        u: {
          name: { required },
          typeId: { required },
          username: { required },
          password: { required },
          email: { email, required },
        },
      };
    } else {
      return {
        u: {
          name: { required },
          typeId: { required },
          username: { required },
          email: { email, required },
        },
      };
    }
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/agents/users/UserEditorDetails.vue